import { useContext } from "react";
import { Users } from "src/context";
import { Processor } from "./Processor";

let state = null;

const IsEnabled = () => {
  const { userIntegrations } = useContext(Users);
  let active_integrations = userIntegrations ?? [];

  if (active_integrations.length === 0) return false;

  let check = active_integrations.filter((x) => x.id === 17);
  if (check.length > 0 && check?.[0]?.user_integrations === "active") {
    return true;
  }

  return false;
};

const getComponent = () => {
  return () => <h1> PandaDoc </h1>;
};

const getConfig = () => {
  return {
    name: "pandadoc",
    type: "contract",
    data: state,
  };
};

const updateData = (data) => {
  state = data;
};

const useProcessor = (user) => {
  return new Processor(user);
};

// check if exist in package or not (prefer contract_config, fallback to legacy pandadoc_config)
const isActiveInpackage = (_package) => {
  const contractConfig = _package?.options?.contract_config?.pandadoc;
  const legacyConfig = _package?.options?.pandadoc_config ?? {};
  const config = contractConfig ?? legacyConfig;
  const hasConfig = contractConfig
    ? Object.keys(contractConfig).length > 0
    : Object.keys(legacyConfig).length > 0;
  return {
    pandadoc: {
      active: hasConfig,
      template_id: config?.template_id ?? "",
    },
  };
};

export default {
  IsEnabled,
  getConfig,
  getComponent,
  updateData,
  useProcessor,
  isActiveInpackage,
};
